module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.eot
// module id = ../../../../../src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.eot
// module chunks = styles